let otpModalOpened = false;

export const markOtpModalOpened = () => {
  otpModalOpened = true;
};

export const isOtpModalOpened = () => otpModalOpened;
